import {FC} from "react";
import {TransactionMainComponent} from "../../../components";
import {DailyTransactionTypeEnum, PageEnum} from "../../../models";

export const PurchasesRefundPage: FC = ({}) => {
    //#region html
    return (
        <>
            <TransactionMainComponent
                formId={PageEnum.ReturnPurchasesBill}
                transactionType={DailyTransactionTypeEnum.PurchasesRefund}
            />
        </>
    );
    //#endregion
};
